export const AUTH_TOKEN = 'auth_token'
export const USER_LOGED = 'user_loged'